import { list as getList } from "~/api/userReferralCountrerparty";
import * as types from "../mutation-types";

export const state = {
  list: null,
  meta: null,
  isLoading: false
};

export const mutations = {
  [types.SET_IS_LOADING_USER_REFERRAL_COUNTERPARTIES](state, status) {
    state.isLoading = status;
  },
  [types.SET_USER_REFERRAL_COUNTERPARTIES](state, data) {
    state.list = data;
  },
  [types.SET_USER_REFERRAL_COUNTERPARTIES_META](state, meta) {
    state.meta = meta;
  }
};

export const actions = {
  fetchUserReferralCounterparties({ commit } = null) {
    commit(types.SET_IS_LOADING_USER_REFERRAL_COUNTERPARTIES, true);

    getList().then((response) => {
      let { data } = response;

      commit(types.SET_USER_REFERRAL_COUNTERPARTIES, data.data);
      commit(types.SET_USER_REFERRAL_COUNTERPARTIES_META, data.meta);
      commit(types.SET_IS_LOADING_USER_REFERRAL_COUNTERPARTIES, false);
    });
  }
};

export const getters = {
  list: (state) => state.list,
  meta: (state) => state.meta,
  isLoading: (state) => state.isLoading
};
